var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconPageContentSaxplzbg8Y(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M119.778,112.895H9.038c-2.952,0-5.85-2.966-5.85-5.988V95.067h121.631v11.999 C124.819,109.932,122.934,112.895,119.778,112.895z M7.193,99.072v7.834c0,0.815,1.086,1.983,1.845,1.983h110.74 c0.594,0,1.036-0.963,1.036-1.823v-7.994H7.193z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M46.271,127.984l-1.576-3.682c1.247-0.534,2.284-1.016,2.846-1.32l0.173-0.094 c0.222-0.121,0.498-0.273,0.565-0.335c0.019-0.033,0.156-0.297,0.383-1.434c0.281-1.407,0.247-3.958,0.217-6.207 c-0.021-1.57-0.041-3.053,0.048-4.109l3.991,0.333c-0.072,0.864-0.054,2.253-0.034,3.723c0.034,2.568,0.07,5.223-0.295,7.045 c-0.555,2.787-1.192,3.534-2.953,4.497l-0.172,0.096C48.54,126.997,47.067,127.644,46.271,127.984z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M81.606,128c-0.997-0.43-2.363-1.039-3.209-1.496l-0.119-0.066c-1.896-1.044-2.389-1.808-2.933-4.535 c-0.364-1.825-0.329-4.442-0.295-6.975c0.02-1.439,0.038-2.8-0.032-3.66l3.992-0.327c0.086,1.051,0.066,2.504,0.046,4.042 c-0.03,2.215-0.063,4.727,0.217,6.137c0.223,1.115,0.346,1.427,0.399,1.514c0.035,0.021,0.314,0.175,0.539,0.299l0.106,0.059 c0.543,0.293,1.569,0.77,2.874,1.332L81.606,128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.255,
    y: 123.944,
    fill: "#282D33",
    width: 43.509,
    height: 4.005
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M124.783,99.143H3.181V28.937c0-2.865,2.343-5.196,5.223-5.196h11.562v4.005H8.403 c-0.671,0-1.217,0.534-1.217,1.191v66.201h113.592V28.937c0-0.657-0.547-1.191-1.22-1.191h-11.522V23.74h11.522 c2.881,0,5.225,2.331,5.225,5.196V99.143z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "30.14,89.805 12.377,89.805 12.377,33.005 19.965,33.005 19.965,37.011 16.382,37.011  16.382,85.799 30.14,85.799  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "115.464,89.805 98.074,89.805 98.074,85.799 111.459,85.799 111.459,37.011 108.034,37.011  108.034,33.005 115.464,33.005  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.478,
    y: 23.684,
    fill: "#282D33",
    width: 4.005,
    height: 64.118
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "29.671,87.802 25.666,87.802 25.666,0.322 80.188,0.322 80.188,4.327 29.671,4.327  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#282D33",
    d: "M87.552,9.459l5.701,5.655h-5.701V9.459 M83.61,0v19.056h19.215L83.61,0L83.61,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.731,
    y: 23.749,
    fill: "#282D33",
    width: 34.96,
    height: 4.005
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.731,
    y: 32.716,
    fill: "#282D33",
    width: 34.96,
    height: 4.005
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "41.384,34.864 36.311,31.623 38.467,28.248 40.515,29.556 44.798,24.233 47.918,26.744  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.731,
    y: 46.805,
    fill: "#282D33",
    width: 34.96,
    height: 4.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.731,
    y: 55.772,
    fill: "#282D33",
    width: 34.96,
    height: 4.005
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "41.384,57.922 36.31,54.678 38.468,51.304 40.515,52.612 44.798,47.288 47.919,49.798  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.731,
    y: 69.861,
    fill: "#282D33",
    width: 34.96,
    height: 4.005
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.731,
    y: 78.829,
    fill: "#282D33",
    width: 34.96,
    height: 4.006
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#282D33",
    points: "41.384,80.98 36.31,77.732 38.468,74.359 40.516,75.669 44.798,70.345 47.919,72.854  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconPageContentSaxplzbg8Y);
export default __webpack_public_path__ + "static/media/reshot-icon-page-content-SAXPLZBG8Y.e8a181c0f15d4f12118b3fb52bc046b1.svg";
export { ForwardRef as ReactComponent };